"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { CalendarClock, Globe2, Lock, ReceiptText, ShieldCheck, Users } from "lucide-react";
import { SERVICE_WHY_ITSHEALER_POINTS } from "@/features/services/constants/service-page-content";
const ICONS = {
  ShieldCheck,
  Lock,
  Users,
  Globe2,
  CalendarClock,
  ReceiptText
} as const;
export function ServiceWhySection() {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      y: 20
    };
    t1 = {
      opacity: 1,
      y: 0
    };
    t2 = {
      once: true,
      margin: "-100px"
    };
    t3 = {
      duration: 0.7,
      ease: "easeOut"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.div initial={t0} whileInView={t1} viewport={t2} transition={t3} className="mx-auto max-w-2xl text-center"><span className="mb-3 block text-xs font-semibold tracking-[0.2em] text-primary uppercase">Why ItsHealer</span><h2 className="font-heading text-[2.5rem] leading-[1.1] font-bold tracking-tight text-foreground sm:text-[3.2rem]">Support That Feels Human and Personal</h2></motion.div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section className="relative border-t border-border bg-muted/30 py-24 sm:py-32"><div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-12">{t4}<div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">{SERVICE_WHY_ITSHEALER_POINTS.map(_temp)}</div></div></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp(point, idx) {
  const Icon = ICONS[point.icon];
  return <motion.div key={point.label} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-50px"
  }} transition={{
    duration: 0.5,
    delay: idx * 0.08
  }} className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5"><span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-primary/10 bg-primary/[0.05] text-primary"><Icon className="h-5 w-5" /></span><p className="text-[15px] font-medium text-foreground">{point.label}</p></motion.div>;
}